var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useMemo } from "react";
import { typeAlert } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useDispatch } from "react-redux";
import { updateStepByPath, updateNextStepInformation } from "ah_utility/workflow";
import { backStepByPath } from "../../../utils/updateStepBack";
import { useCompleteStep } from "../../../utils/responseComplete";
var useActions = function (setOpenDrawerUpload, setPdfFile, setFileName, setIdDocumentClient, setModalDocumentClient, setUrlDocumentClient, setDocName, isVidaTermino, navigate, navigateNext, STEP, id, setOpenModalBackConfirm, isPlan, isDocumentClient, workFlowId, instanceId, currentStep, nextStep, currentStepId, nextStepId, pathLocation, navigation) {
    var dispatch = useDispatch();
    ////LLAMADO API COMPLETE_STEP
    var _a = useCompleteStep(), runComplete = _a.runComplete, loadingComplete = _a.loadingComplete, responseComplete = _a.responseComplete, errorComplete = _a.errorComplete;
    var handleNext = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, prevStep, currentStep_1, nextStep_1, err_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (navigation === null || navigation === void 0 ? void 0 : navigation.isLast) {
                        navigate("".concat(navigation === null || navigation === void 0 ? void 0 : navigation.next));
                        return [2 /*return*/];
                    }
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, runComplete({
                            workFlowId: workFlowId,
                            instanceId: instanceId,
                            currentStep: currentStep || currentStepId,
                            nextStep: nextStep || nextStepId,
                        })];
                case 2:
                    res = _d.sent();
                    if (res) {
                        updateStepByPath(pathLocation || "");
                        prevStep = (_a = res.upcomingFormStep) === null || _a === void 0 ? void 0 : _a.prevSteps[0];
                        currentStep_1 = (_b = res.upcomingFormStep) === null || _b === void 0 ? void 0 : _b.id;
                        nextStep_1 = (_c = res.upcomingFormStep) === null || _c === void 0 ? void 0 : _c.nextSteps[0];
                        updateNextStepInformation({
                            stepKey: pathLocation || "",
                            data: {
                                currentStep: currentStep_1,
                                nextStep: nextStep_1,
                                prevStep: prevStep,
                            },
                        });
                        navigate("".concat(navigation === null || navigation === void 0 ? void 0 : navigation.next));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _d.sent();
                    console.error("Error completing step:", err_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [
        workFlowId,
        instanceId,
        currentStep,
        nextStep,
        currentStepId,
        nextStepId,
        pathLocation,
        navigation === null || navigation === void 0 ? void 0 : navigation.next,
        navigation === null || navigation === void 0 ? void 0 : navigation.isLast,
        runComplete,
        updateStepByPath,
        updateNextStepInformation,
        navigate,
    ]);
    var handleSuccess = function (message, dataClearAction, callback, setSeeToast, showToastSuccessMessage, setOpenModal, responseOneQuote) {
        showToastSuccessMessage(message, typeAlert.success, setSeeToast);
        setOpenModal(false);
        dispatch(dataClearAction());
        callback(responseOneQuote);
    };
    var handlePrevious = useCallback(function () {
        if (id === undefined) {
            setOpenModalBackConfirm(true);
        }
        else {
            if (isPlan) {
                navigate("/");
            }
            else {
                backStepByPath(pathLocation || "");
                navigate("".concat(navigation === null || navigation === void 0 ? void 0 : navigation.back));
            }
        }
    }, []);
    var onClickBack = useCallback(function () {
        if (isDocumentClient === "true") {
            navigate("/pending-info-page/");
        }
        else {
            handlePrevious();
        }
    }, [handlePrevious]);
    var handleCloseBackModal = useCallback(function () {
        setOpenModalBackConfirm(false);
    }, []); // No dependencies
    var handleBackFromModal = useCallback(function () {
        navigate("/");
    }, []); // No dependencies
    var handleClickContextMenu = useCallback(function (item, params) {
        var _a, _b, _c;
        switch (item.id) {
            case "1":
                setOpenDrawerUpload(true);
                setPdfFile(undefined);
                setFileName("");
                setIdDocumentClient((_a = params === null || params === void 0 ? void 0 : params.row) === null || _a === void 0 ? void 0 : _a.id);
                break;
            case "2":
                setModalDocumentClient(true);
                setUrlDocumentClient((_b = params === null || params === void 0 ? void 0 : params.row) === null || _b === void 0 ? void 0 : _b.documentClientUrl);
                setDocName((_c = params === null || params === void 0 ? void 0 : params.row) === null || _c === void 0 ? void 0 : _c.docType);
                break;
            default:
                break;
        }
    }, []);
    // Return the memoized object
    return useMemo(function () { return ({
        handleNext: handleNext,
        handlePrevious: handlePrevious,
        onClickBack: onClickBack,
        handleCloseBackModal: handleCloseBackModal,
        handleBackFromModal: handleBackFromModal,
        handleClickContextMenu: handleClickContextMenu,
        handleSuccess: handleSuccess,
        loadingComplete: loadingComplete,
    }); }, [
        handleNext,
        handlePrevious,
        onClickBack,
        handleCloseBackModal,
        handleBackFromModal,
        handleClickContextMenu,
        handleSuccess,
        loadingComplete,
    ]);
};
export default useActions;
